import { Box, Button, IconButton, InputAdornment, Stack, TextField, Typography } from '@mui/material';
import { Icon } from '@iconify/react';
import { AuthForm } from 'hooks/useAuthForm';
import SubmitError from './SubmitError';

export default function SetPasswordForm({ auth }: { auth: AuthForm }) {
  const { form, ui, loading, submitError, fieldErrors } = auth;

  return (
    <Stack
      component="form"
      onSubmit={(e) => {
        e.preventDefault();
        auth.handleSetPassword();
      }}
      spacing={2}
      sx={{ flex: 1 }}
    >
      <Typography variant="body1" fontWeight={500}>
        Придумайте пароль
      </Typography>
      <Typography variant="body2" color="text.secondary">
        Минимум 4 символова
      </Typography>
      <TextField
        fullWidth
        label="Пароль"
        type={ui.showRegPassword ? 'text' : 'password'}
        value={form.regPassword}
        onChange={(e) => {
          auth.updateForm({ regPassword: e.target.value });
          auth.setFieldError('regPassword', null);
          auth.setSubmitError(null);
        }}
        onBlur={() =>
          auth.setFieldError(
            'regPassword',
            form.regPassword ? auth.validatePassword(form.regPassword) : null
          )
        }
        error={!!fieldErrors.regPassword}
        helperText={fieldErrors.regPassword ?? undefined}
        autoComplete="new-password"
        autoFocus
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                type="button"
                onClick={() => auth.updateUi({ showRegPassword: !ui.showRegPassword })}
                edge="end"
              >
                <Icon icon={ui.showRegPassword ? 'mdi:eye-off' : 'mdi:eye'} />
              </IconButton>
            </InputAdornment>
          )
        }}
      />
      <TextField
        fullWidth
        label="Повторите пароль"
        type={ui.showRegPassword ? 'text' : 'password'}
        value={form.regPasswordConfirm}
        onChange={(e) => {
          auth.updateForm({ regPasswordConfirm: e.target.value });
          auth.setFieldError('regPasswordConfirm', null);
        }}
        onBlur={() => {
          if (form.regPasswordConfirm && form.regPassword !== form.regPasswordConfirm) {
            auth.setFieldError('regPasswordConfirm', 'Пароли не совпадают');
          }
        }}
        error={!!fieldErrors.regPasswordConfirm}
        helperText={fieldErrors.regPasswordConfirm ?? undefined}
        autoComplete="new-password"
      />
      <Box sx={{ mt: 'auto !important' }}>
        <SubmitError error={submitError} />
        <Button
          fullWidth
          variant="contained"
          color="primary"
          size="large"
          type="submit"
          disabled={!form.regPassword || !form.regPasswordConfirm || loading}
          sx={{ mt: submitError ? 1 : 0 }}
        >
          {loading ? 'Сохранение...' : 'Завершить регистрацию'}
        </Button>
      </Box>
    </Stack>
  );
}
